module.exports = __webpack_public_path__ + "static/media/plan-TH3-desktop-en.5bd2fe6e.png";